<template>
  <div class="wrap">
    <div class="browser">
      <div class="browser-bar">
        <ul>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
      <div class="browser-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
$red: #DF7166;
$orange: #E6C646;
$green: #5CCC8B;
$grey: #EEE;
$shadow: rgba(0, 0, 0, 0.2);

.wrap {
  vertical-align: middle;
  box-sizing: border-box;
}

.browser {
  width: 100%;
  margin: 0 auto;
  background: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 2px 6px $shadow;
  margin-top: 20px;

  @media (min-width: 640px) {
	  margin-top: 0;
  }
}

.browser-bar {
  background: $grey;
  height: 34px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  text-align: left;
  padding: 0;

  ul {
    display: inline-block;
    line-height: 34px;
    padding-left: 15px;
  }

  li {
    display: inline-block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    margin-right: 4px;

    &:nth-of-type(1) {
      background: $red;
    }

    &:nth-of-type(2) {
      background: $orange;
    }

    &:nth-of-type(3) {
      background: $green;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/Browser.vue